import React, { useState } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default (asyncSaga) => (WrappedComponent) => {
  const WithDynamicSaga = (props) => {
    useState(useInjectReducerAndSaga(null, asyncSaga));
    return <WrappedComponent {...props} />;
  };
  WithDynamicSaga.displayName = `withSaga(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;
  hoistNonReactStatics(WithDynamicSaga, WrappedComponent);
  return WithDynamicSaga;
};
